<template>
  <div class="top-header">
    <h2
      v-if="isTitle"
      class="page-title text-left text-28 text-text pt-8 tracking-tight leading-tight"
    >
      <p class="text-primary" style="margin-bottom:5px;">
        {{ $t("Choose One") }}
      </p>
      <p class="text-content" style="margin-bottom:5px;">
        {{ $t("Cause to Support") }}
      </p>
    </h2>
    <div class="top-search flex items-center flex-grow">
      <router-link to="/dashboard" v-if="!isTitle">
        <Close icon="back" :isWithoutClass="true" />
      </router-link>
      <div
        class="top-search-container flex justify-between items-center relative pr-5"
      >
        <input
          :value="value"
          @input="$emit('input', $event.target.value)"
          type="text"
          :placeholder="$t('Search')"
          @focus="$emit('show-cause-filter')"
        />

        <div class="absolute icons-box">
          <button
            v-if="isPartner"
            type="button"
            @click="$emit('map-filter-handler')"
          >
            <img :src="`${$store.state.appUrl}/img/pwa/filter.svg`" />
          </button>

          <span :style="barStyle">|</span>

          <button type="button" @click="$emit('show-google-map-handler')">
            <img :src="`${$store.state.appUrl}/img/pwa/map.svg`" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defaults } from "autoprefixer";
import Close from "../UI/Close.vue";
import SvgIcon from "../UI/SvgIcon";
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    isPartner: {
      type: Boolean,
      default: true
    },
    isSignup: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Close,
    SvgIcon
  },
  computed: {
    isTitle() {
      return !this.isPartner && this.isSignup;
    },
    barStyle() {
      return {
        "font-size": "38px",
        color: "#000000",
        "font-weight": "100",
        visibility: this.isPartner ? "visible" : "hidden"
      };
    }
  }
};
</script>
